import { TagWrapper } from '@/home/HeroCardsReturnUser/LinkCards/VDPLinks/StatusTag';
import { addNewestInventorySortToCvnaId } from '@/home/RecentSearches/RecentSearches';
import { SavedSearch } from '~/contracts/common';
import Chevron from '~/icons/Chevron';
import { nativeSrpPayload } from '~/native/home/utils';

type OwnProps = {
  links: SavedSearch[];
};

export default function SavedSearchLink({ links }: OwnProps) {
  return links.map(link => {
    const {
      name,
      savedSearchId,
      cvnaId,
      totalNewVehicles = 0,
      totalMatchingVehicles
    } = link;

    return (
      <div
        key={savedSearchId}
        className="py-2xl first:pt-0 last:pb-0"
        data-qa="saved-search-links"
      >
        <a
          href={`/cars/filters?cvnaid=${addNewestInventorySortToCvnaId(
            cvnaId
          )}`}
          data-analytics-id="Home feed card"
          data-analytics-attributes={JSON.stringify({
            description: 'Search Card',
            type: 'saved',
            item: 'search'
          })}
          data-native-payload={nativeSrpPayload}
          className="group grid grid-cols-[1fr_16px] items-center gap-xl"
        >
          <div className="flex flex-col gap-8 overflow-hidden text-blue-6">
            <div className="truncate tl-header-s" title={name}>
              {name}
            </div>
            <div className="flex items-center gap-8">
              {totalMatchingVehicles != null && (
                <p className="tl-body-s" data-qa="saved-search-results-count">
                  {totalMatchingVehicles.toLocaleString()} results
                </p>
              )}
              {totalNewVehicles > 0 && (
                <TagWrapper className=" bg-marketplace-purple">
                  {totalNewVehicles.toLocaleString()} New
                </TagWrapper>
              )}
            </div>
          </div>
          <div className="flex-shrink-0">
            <Chevron className="group-hover:stroke-blue-3" />
          </div>
        </a>
      </div>
    );
  });
}
